import { Component } from '@angular/core';

@Component({
    selector: 'op-transport',
    templateUrl: './transport.component.html'
})
export class TransportComponent {
}
